// Champion Phase B strings (Golem, Lich, generic abilities, statuses, Soul) — Spanish.

import type { gameLegendsKindsEn } from './gameLegendsKindsEn.js';

export const gameLegendsKindsEs: Record<keyof typeof gameLegendsKindsEn, string> = {
  'champion.kind.golem': 'Gólem',
  'champion.kind.lich': 'Liche',
  'champion.ability.bulwark': 'Baluarte',
  'champion.ability.withering': 'Marchitar',
  'champion.ability.ascend': 'Ascender',
  'champion.ability.witheringHint':
    'Maldice a todo enemigo a {radius} de una casilla a hasta {range} casillas: sus ataques se debilitan durante {seconds}s. Sin daño.',
  'champion.ability.bulwarkHint':
    'Mantén la línea: guarnécete en una ciudad tuya adyacente o fortifícate donde está. En ambos casos recibe menos daño; salir recarga {seconds}s.',
  'champion.ability.ascendHint':
    'Una vez por vida, con el Alma llena: +{attack} de ataque y +{hp} de salud máxima.',
  'champion.ability.reason.soul': 'Requiere el Alma llena ({have} / {need}).',
  'champion.ability.reason.ascended': 'Ya ha ascendido.',
  'champion.ability.reason.inert': 'Inerte mientras está guarnecido.',
  'champion.ability.targetingRange':
    'Elige una casilla objetivo a hasta {range} casillas (Esc para cancelar)',
  'champion.bulwark.fortify': 'Fortificar aquí',
  'champion.bulwark.garrison': 'Guarnecer en {city}',
  'champion.bulwark.liftGarrison': 'Salir de la ciudad',
  'champion.bulwark.liftFortify': 'Romper la fortificación',
  'champion.state.garrison': 'Guarnecido: inerte dentro de la ciudad, que recibe menos daño.',
  'champion.state.fortify': 'Fortificado: no puede moverse y recibe menos daño.',
  'champion.soul.label': 'Alma',
  'champion.soul.value': '{soul} / {max}',
  'champion.soul.ready': 'Ascender listo',
  'champion.soul.hint': 'Crece 1 por cada enemigo que muere a menos de {range} casillas.',
  'champion.phylactery.fallbackCity': 'su ciudad de invocación',
  'champion.phylactery.panel': 'Ligado a {city}: muere si esa ciudad cae.',
  'champion.status.title': 'Estados',
  'champion.status.wither': 'Marchito',
  'champion.status.fortify': 'Fortificado',
  'champion.status.garrison': 'Guarnecido',
  'champion.status.ascended': 'Ascendido',
  'champion.status.witherHint': 'Tiradas de ataque -{mag}',
  'champion.status.fortifyHint': 'No puede moverse, recibe menos daño',
  'champion.status.garrisonHint': 'Dentro de una ciudad, inerte',
  'champion.status.ascendedHint': 'Tiradas de ataque +{mag}',
  'champion.status.left': 'Quedan {seconds}s',
  'champion.err.condition_unmet': 'No se cumplen las condiciones de esa habilidad.',
  'champion.err.condition_unmet.bulwark':
    'Baluarte necesita una ciudad tuya adyacente (guarnecer) o la casilla del propio Gólem (fortificar).',
  'champion.err.condition_unmet.ascend': 'Ascender necesita el Alma llena y solo funciona una vez.',
  'champion.err.fortified': 'Un Gólem fortificado no puede moverse. Rompe antes la fortificación.',
  'champion.summon.blurb.dragon':
    'Un Dragón acude al llamado de una gran ciudad. Solo un Campeón a la vez.',
  'champion.summon.blurb.golem':
    'Un Gólem surge de la forja: un guardián de piedra lento que ancla tus ciudades. Solo un Campeón a la vez.',
  'champion.summon.blurb.lich':
    'Un Liche surge de la necrópolis: un frágil hechicero que se alimenta de los caídos. Solo un Campeón a la vez.',
  'champion.summon.offeredBy': 'Tu doctrina dominante ofrece el {kind}.',
  'champion.summon.phylactery': 'Ligado a esta ciudad: si cae, el Liche muere.',
  'champion.summon.phylacheryHere':
    'El filacterio del Liche está aquí: si esta ciudad cae, el Liche muere.',
  'champion.site.golem_forge': 'Forja de Gólems',
  'champion.site.necropolis': 'Necrópolis',
  'event.legend.ability.firestorm': 'Tormenta de fuego',
  'event.legend.ability.bulwark': 'Baluarte',
  'event.legend.ability.withering': 'Marchitar',
  'event.legend.ability.ascend': 'Ascender',
  'event.legend.ability.generic': 'Habilidad de Campeón',
  'event.detail.legend.firestorm': '{hits} alcanzados, {kills} abatidos',
  'event.detail.legend.withering': '{hits} marchitados',
  'event.detail.legend.bulwark': 'El Gólem cambia de postura',
  'event.detail.legend.ascend': 'El Liche asciende',
  'event.detail.legend.generic': '{hits} afectados',
  'cinematic.legendSummoned.subtitle.dragon': 'Un dragón responde a tu llamada.',
  'cinematic.legendSummoned.subtitle.golem': 'Un guardián de piedra responde a tu llamada.',
  'cinematic.legendSummoned.subtitle.lich': 'Un maestro de los muertos responde a tu llamada.',
  'cinematic.legendSummoned.kid.dragon': '¡Un dragón gigante se ha unido a ti!',
  'cinematic.legendSummoned.kid.golem': '¡Un gólem de piedra gigante se ha unido a ti!',
  'cinematic.legendSummoned.kid.lich': '¡Un mago esqueleto espeluznante se ha unido a ti!',
  'cinematic.legendFallen.kid.dragon': '¡Tu dragón se ha caído!',
  'cinematic.legendFallen.kid.golem': '¡Tu gólem de piedra se ha caído!',
  'cinematic.legendFallen.kid.lich': '¡Tu mago esqueleto se ha caído!',
};
